import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import SystemsWhispererSection from "@/components/sections/SystemsWhispererSection";

const SystemsWhisperer = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-20">
        <SystemsWhispererSection />
      </main>
      <Footer />
    </div>
  );
};

export default SystemsWhisperer;
